module.exports = __webpack_public_path__ + "static/media/clicky-game.24a4e859.png";